/*
 * Pinkies™ Toe Wellness Wraps — Landing Page Scripts
 * File: pinkies-landing.js
 * Upload to: themes/[your-theme]/assets/pinkies-landing.js
 * Version: Final pre-launch — March 2026
 */

// Qty selector interaction
  document.querySelectorAll('.qty-option').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.qty-option').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  // See More reviews toggle
  function toggleReviews() {
    const extra = document.getElementById('reviews-extra');
    const btn = document.getElementById('see-more-btn');
    const isOpen = extra.classList.contains('visible');
    if (isOpen) {
      extra.classList.remove('visible');
      btn.classList.remove('open');
      btn.innerHTML = 'See More Feedback <span class="arrow">↓</span>';
    } else {
      extra.classList.add('visible');
      btn.classList.add('open');
      btn.innerHTML = 'Show Less <span class="arrow">↓</span>';
    }
  }

  // Scroll fade-in for cards
  const observer = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.step-card, .testimonial-card, .usecase-card, .bundle-card, .science-stat, .guarantee-item').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(20px)';
    el.style.transition = 'opacity 0.55s ease, transform 0.55s ease';
    observer.observe(el);
  });

  // Floating bar logic
  const waitlistBar = document.getElementById('waitlist-bar');
  const stickyAtc = document.getElementById('sticky-atc');
  const backToTop = document.getElementById('back-to-top');
  const heroSection = document.querySelector('.hero');
  let waitlistDismissed = false;
  let waitlistTimer = null;

  // Show waitlist bar after 4 seconds on page load
  waitlistTimer = setTimeout(() => {
    if (!waitlistDismissed) {
      waitlistBar.classList.add('visible');
    }
  }, 4000);

  // Closing the floating bar only hides the bar — the on-page #waitlist section remains
  function closeWaitlist() {
    waitlistDismissed = true;
    waitlistBar.classList.remove('visible');
    clearTimeout(waitlistTimer);
    // Gently nudge user to the on-page section after a beat
    setTimeout(() => {
      const hint = document.getElementById('waitlist');
      if (hint) hint.style.outline = '2px solid rgba(192,40,78,0.4)';
      setTimeout(() => { if (hint) hint.style.outline = ''; }, 1200);
    }, 300);
  }

  // Sticky ATC — shows when hero leaves viewport, hides floating waitlist bar
  const heroObserver = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) {
        stickyAtc.classList.add('visible');
        waitlistBar.classList.remove('visible');
      } else {
        stickyAtc.classList.remove('visible');
        if (!waitlistDismissed) {
          setTimeout(() => waitlistBar.classList.add('visible'), 600);
        }
      }
    });
  }, { threshold: 0 });

  if (heroSection) heroObserver.observe(heroSection);

  // Back to top button
  window.addEventListener('scroll', () => {
    backToTop.classList.toggle('visible', window.scrollY > 400);
  });
